export const actionTypes = {
    SESSION_START: 'session_start'
}